import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import ModalPlaning from '../../components/planing/ModalPlaning'
import {closeModalPlaning, abrirModalSeleccionarVerracoPlaning, totalesPlaning, asignarVerracos, anadirPlaning, onDeleteVerracoPlaning, seleccionarTodosModalPlaning,
  cargarVerracosPlanificados, deleteSeleccionVerracoPlaning, onDeleteVerracoPlaningSuccess, cerrarModalSeleccionarVerracoPlaning, anadirVerracosPlaning,
  deSeleccionarTodosModalPlaning, obtenerDatosVerracoPlaning, seleccionarTodosSugerenciasPlanning, deSeleccionarTodosSugerenciasPlanning, seleccionarTodosQuitarSugerenciasPlanning, deSeleccionarTodosQuitarSugerenciasPlanning, obtenerPrevisionVerracos} from '../../actions/planing/planing'
import {comboOperario} from '../../actions/combos/combos'

export function mapStateToProps (state) {
  return {
    ...state.planing,
    numeroRegistrosPorPagina: state.common.numeroRegistrosPorPagina,
    paginaActual: state.common.paginaActual,
    formSimpleTable: state.form.simpleTable,
    auth: state.auth,
    combos: state.combos
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      closeModalPlaning,
      abrirModalSeleccionarVerracoPlaning,
      totalesPlaning,
      asignarVerracos,
      anadirPlaning,
      onDeleteVerracoPlaning,
      seleccionarTodosModalPlaning,
      deSeleccionarTodosModalPlaning,
      cargarVerracosPlanificados,
      deleteSeleccionVerracoPlaning,
      onDeleteVerracoPlaningSuccess,
      cerrarModalSeleccionarVerracoPlaning,
      anadirVerracosPlaning,
      obtenerDatosVerracoPlaning,
      comboOperario,
      seleccionarTodosSugerenciasPlanning,
      deSeleccionarTodosSugerenciasPlanning,
      seleccionarTodosQuitarSugerenciasPlanning,
      deSeleccionarTodosQuitarSugerenciasPlanning,
      obtenerPrevisionVerracos
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ModalPlaning))